import { NgModule } from '@angular/core';
import { GlobalAlertsComponent } from './global-alerts.component';
import { EdAssistUIAlertModule } from '../alert';
import { EdAssistUIStickyModule } from '../sticky';
import { CommonModule } from '@angular/common';

const COMPONENTS = [GlobalAlertsComponent];

@NgModule({
	imports: [EdAssistUIAlertModule, CommonModule, EdAssistUIStickyModule],
	exports: COMPONENTS,
	declarations: COMPONENTS
})
class EdAssistUIGlobalAlertsModule {}

export { EdAssistUIGlobalAlertsModule, GlobalAlertsComponent };
